import { Avatar } from '@ideon-api/ideon-ui'

type Props = { actorType: string; actorId: string | null; actorName: string | null }

const SYSTEM_LABELS = new Map([
  ['system', 'System'],
  ['auth0_action', 'Auth0'],
])

export function HistoryActor({ actorType, actorId, actorName }: Props) {
  const systemLabel = SYSTEM_LABELS.get(actorType)
  if (systemLabel) {
    return (
      <span className="flex items-center gap-2">
        <Avatar variant="system" label={systemLabel} />
        <span>{systemLabel}</span>
      </span>
    )
  }

  // A blank name falls back to a short id fragment (after the provider prefix, e.g. `auth0|`) so two unnamed actors stay tellable apart; the full id is the tooltip.
  const name = actorName?.trim() || (actorType === 'service_account' ? 'Unknown machine user' : 'Unknown user')
  if (!actorName?.trim() && !actorId) return <span>—</span>

  return (
    <span className="flex items-center gap-2" title={actorId ?? undefined}>
      <Avatar name={name} />
      <span className="break-all">{name}</span>
      {!actorName?.trim() && actorId && <span className="text-ideon-gray-70">{actorId.split('|').pop()?.slice(0, 8)}</span>}
    </span>
  )
}
